import { FC, useEffect } from 'react';
import { FormattedMessage } from 'dibs-react-intl';

import { getAbTestV2, trackAbTestV2Variant } from 'dibs-buyer-layout/exports/clientABTestV2';

const AB_TEST_NAME = 'PdpMakeOfferCTACopy';

let trackingFired = false;

export const PdpSharedTestMakeOfferCTACopy: FC = () => {
    const isVariant = getAbTestV2(AB_TEST_NAME)?.variant === 'variant';

    useEffect(() => {
        if (!trackingFired) {
            trackAbTestV2Variant(AB_TEST_NAME);
            trackingFired = true;
        }
    }, []);

    return isVariant ? (
        <FormattedMessage id="abf.MakeOfferCopyTest.variant" defaultMessage="Make Offer" />
    ) : (
        <FormattedMessage id="abf.MakeOfferCopyTest.control" defaultMessage="Make An Offer" />
    );
};
